import PersonalSettings from './PersonalSettings';

export default PersonalSettings;
